<template>
  <div class="new-order-skeleton">
    <template v-if="isWelcomeSet">
      <SkeletonOneString
        class="new-order-skeleton__item new-order-skeleton__item--welcome-banner"
        :height="bannerHeight"
        :border-radius="16"
        width="100%"
      />
      <div
        v-for="index in 2"
        :key="index"
        class="new-order-skeleton__welcome-menu"
      >
        <SkeletonOneString
          class="new-order-skeleton__item new-order-skeleton__item--welcome-menu-title"
          :height="16"
          :border-radius="14"
          width="216px"
        />
        <div class="new-order-skeleton__packs">
          <SkeletonOneString
            v-for="n in 4"
            :key="n"
            class="new-order-skeleton__item"
            :height="204"
            :border-radius="16"
            width="100%"
          />
        </div>
      </div>
    </template>
    <template v-else>
      <template v-if="isMenuTypesLoading">
        <SkeletonOneString
          class="new-order-skeleton__item new-order-skeleton__item--title"
          :height="16"
          width="216px"
          :border-radius="14"
        />
        <div class="new-order-skeleton__buttons">
          <SkeletonOneString
            v-for="n in 2"
            :key="n"
            class="new-order-skeleton__item"
            :height="48"
            :border-radius="16"
          />
        </div>
        <SkeletonOneString
          class="new-order-skeleton__item new-order-skeleton__item--title"
          :height="16"
          width="216px"
          :border-radius="14"
        />
        <div class="new-order-skeleton__buttons">
          <SkeletonOneString
            v-for="n in 5"
            :key="n"
            class="new-order-skeleton__item"
            :height="48"
            :border-radius="16"
          />
        </div>
        <div
          v-if="hasCalories"
          class="new-order-skeleton__calories"
        >
          <SkeletonOneString
            class="new-order-skeleton__item"
            :height="30"
            width="100%"
            :border-radius="14"
          />
        </div>
      </template>
      <SkeletonOneString
        class="new-order-skeleton__item new-order-skeleton__item--title"
        :height="16"
        width="216px"
        :border-radius="14"
      />
      <div class="new-order-skeleton__buttons">
        <SkeletonOneString
          class="new-order-skeleton__item"
          :height="48"
          :border-radius="16"
          width="100%"
        />
      </div>
      <div class="new-order-skeleton__pack-info">
        <SkeletonOneString
          class="new-order-skeleton__item"
          :height="10"
          :border-radius="10"
          width="216px"
        />
      </div>
      <div class="new-order-skeleton__packs">
        <SkeletonOneString
          v-for="n in 4"
          :key="n"
          class="new-order-skeleton__item"
          :height="204"
          :border-radius="16"
          width="100%"
        />
      </div>
      <SkeletonOneString
        class="new-order-skeleton__item new-order-skeleton__item--title"
        :height="16"
        width="216px"
        :border-radius="14"
      />
      <div class="new-order-skeleton__buttons">
        <SkeletonOneString
          v-for="n in 5"
          :key="n"
          class="new-order-skeleton__item"
          :height="48"
          :border-radius="16"
        />
      </div>
      <SkeletonOneString
        class="new-order-skeleton__item new-order-skeleton__item--title new-order-skeleton__item--small-mg"
        :height="16"
        width="216px"
        :border-radius="14"
      />
      <SkeletonOneString
        class="new-order-skeleton__item new-order-skeleton__item--title"
        :height="16"
        width="216px"
        :border-radius="14"
      />
    </template>

    <div class="new-order-skeleton__delivery">
      <div>
        <SkeletonOneString
          class="new-order-skeleton__item"
          :height="16"
          :border-radius="14"
          :length="25"
        />
        <SkeletonOneString
          class="new-order-skeleton__item"
          :height="12"
          :border-radius="14"
          :length="20"
        />
        <SkeletonOneString
          class="new-order-skeleton__item"
          :height="12"
          :border-radius="14"
          :length="15"
        />
        <SkeletonOneString
          class="new-order-skeleton__item"
          :height="12"
          :border-radius="14"
          :length="23"
        />
      </div>
      <SkeletonOneString
        class="new-order-skeleton__item"
        :height="96"
        width="109px"
        :border-radius="16"
      />
    </div>
    <div class="new-order-skeleton__buttons">
      <SkeletonOneString
        class="new-order-skeleton__item"
        :height="48"
        :border-radius="16"
        width="100%"
      />
    </div>
    <div
      v-if="isWelcomeSet"
      class="new-order-skeleton__buttons new-order-skeleton__buttons--welcome-set"
    >
      <SkeletonOneString
        class="new-order-skeleton__item"
        :height="48"
        :border-radius="16"
        width="100%"
      />
    </div>
  </div>
</template>

<script>
import SkeletonOneString from '@/components/core/ui/SkeletonOneString'

export default {
  name: 'PageSkeleton',

  components: {
    SkeletonOneString,
  },

  props: {
    isMenuTypesLoading: {
      type: Boolean,
      default: true,
    },

    isWelcomeSet: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    hasCalories () {
      return this.$route.path.includes('high')
    },

    bannerHeight () {
      return window.innerWidth / 2.5
    },
  },
}
</script>

<style lang="scss">
.new-order-skeleton {
  &__item {
    margin: 0;

    &--title {
      border-radius: 14px;
      margin-top: 32px;
    }

    &--small-mg {
      margin-top: 20px;
    }

    &--welcome-banner {
      margin-top: 24px;
      height: 100px;
    }

    &--welcome-menu-title {
      margin-bottom: 20px;
    }
  }

  &__buttons {
    display: flex;
    gap: 8px;
    margin-top: 20px;

    &--welcome-set {
      margin-top: 8px;
    }
  }

  &__calories {
    position: relative;
    margin-top: 16px;
  }

  &__calories::before {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    border-top: 15px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 15px solid #f6f6f6;
    border-left: 15px solid transparent;
    top: -22px;
    left: 0;
    right: 0;
    margin: 0 auto;
  }

  &__pack-info {
    text-align: center;
    margin: 3px 0 6px;
  }

  &__packs {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 204px 204px;
    gap: 8px;
  }

  &__delivery {
    display: grid;
    grid-template-columns: auto 109px;
    grid-template-rows: 96px;
    margin-top: 12px;
    margin-bottom: 20px;
  }

  &__welcome-menu {
    margin: 36px 0;
  }
}
</style>
